import { render, staticRenderFns } from "./VehiclesCreateModal.vue?vue&type=template&id=3131b55a"
import script from "./VehiclesCreateModal.vue?vue&type=script&lang=js"
export * from "./VehiclesCreateModal.vue?vue&type=script&lang=js"
import style0 from "./VehiclesCreateModal.vue?vue&type=style&index=0&id=3131b55a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports